import RequestStatus from '../store/schema/RequestStatus';
import { MeetingRequestViewState } from 'owa-meeting-message/lib/store/schema/MeetingRequestViewState';
import { action } from 'satcheljs';

export default action(
    'setConflictsRequestStatus',
    (status: RequestStatus, meetingRequestViewState: MeetingRequestViewState) => ({
        status,
        meetingRequestViewState,
    })
);
